import { Link, useNavigate } from 'react-router-dom';
import { LogOut } from 'lucide-react';
import { useAppState } from '../../hooks/useAppState';
import { PaladinLogo } from '../shared/PaladinLogo';

export function Navbar() {
  const { user, isAuthenticated, logout } = useAppState();
  const navigate = useNavigate();

  function handleLogout() {
    logout();
    navigate('/');
  }

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 border-b border-white/[0.03] bg-[#060A12]/70 backdrop-blur-xl">
      <div className="max-w-[1200px] mx-auto px-8 h-16 flex items-center justify-between">
        <Link to={isAuthenticated ? '/dashboard' : '/'} className="flex items-center gap-2.5 no-underline">
          <PaladinLogo size={28} shimmer />
          <span className="text-[13px] font-mono font-semibold tracking-[0.14em] uppercase text-white/70">
            PALADIN
          </span>
        </Link>

        {isAuthenticated && user && (
          <div className="flex items-center gap-4">
            <span className="text-[11px] font-mono text-white/40">
              {user.discordUsername}
            </span>
            <span className={`text-[10px] font-mono tracking-wider px-2.5 py-0.5 rounded-full border ${
              user.role === 'Inner Circle'
                ? 'border-[#D4A843]/30 text-[#D4A843]/80'
                : 'border-[#4A9EFF]/30 text-[#4A9EFF]/80'
            }`}>
              {user.role}
            </span>
            <button
              onClick={handleLogout}
              className="text-white/30 hover:text-white/70 transition-colors duration-300 cursor-pointer"
              title="Sign out"
            >
              <LogOut className="w-3.5 h-3.5" />
            </button>
          </div>
        )}
      </div>
    </nav>
  );
}
